import colors from 'theme/colors';

/**
 * Tokens da lista de participantes.
 *
 * Os chips antigos usavam texto branco sobre `colors.success` (#2BC866) e sobre
 * o literal CSS `orange` — ambos ficam em ~2,2:1 e reprovam WCAG AA. Aqui cada
 * chip é fundo claro + texto escuro, todos acima de 4,5:1 sobre o próprio fundo.
 */

export const PARTICIPANT_STATUS = {
    ACTIVE: 'active',
    USED: 'used',
    REFUNDED: 'refunded',
};

export const statusChip = {
    [PARTICIPANT_STATUS.ACTIVE]: {
        label: 'Ativo',
        bg: '#EDF9F2',
        text: '#0F6B31',
        border: '#B7E5C9',
    },
    [PARTICIPANT_STATUS.USED]: {
        label: 'Utilizado',
        bg: '#F7EFFF',
        text: '#6D14CC',
        border: '#DFC8F8',
    },
    [PARTICIPANT_STATUS.REFUNDED]: {
        label: 'Estornado',
        bg: '#FDEDEE',
        text: '#A31621',
        border: '#F5C2C7',
    },
};

/**
 * "Tipo" (ingresso/produto) deixa de usar o mesmo chip colorido do status —
 * eram dois eixos de informação com a mesma aparência, e o olho não separava
 * estado de categoria. Tipo vira um rótulo neutro e discreto.
 */
export const typeLabel = {
    ticket: 'Ingresso',
    product: 'Produto',
};

export function statusOf(participant) {
    if (participant?.status !== 'active') return PARTICIPANT_STATUS.REFUNDED;
    if (participant?.used) return PARTICIPANT_STATUS.USED;
    return PARTICIPANT_STATUS.ACTIVE;
}

/** Só quem está ativo e ainda não entrou pode receber check-in. */
export function canCheckIn(participant) {
    return statusOf(participant) === PARTICIPANT_STATUS.ACTIVE;
}

export const formatInt = (value) => Number(value || 0).toLocaleString('pt-BR');

export function formatDateTime(value) {
    if (!value) return '';

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '';

    return `${parsed.toLocaleDateString('pt-BR')} · ${parsed.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
    })}`;
}
